import React from 'react';
import { useQuery } from '@apollo/client';
import IFieldsetProps from '../../../utils/types/IFieldsetProps';
import { GET_LEGO_CATEGORIES_QUERY } from '../../../utils/statApi/EntityStatusApi';
import QueryBasedDropdown from './queryBasedDropdown/QueryBasedDropdown';
import IDropdownReference from '../../../utils/types/IDropdownReference';
import { ILegoCategory } from '../../companies/detail/forms/CompanyLegalEntityTerminationInfoForm';

interface ILegoCategoryDropdownProps extends IFieldsetProps {
  watchTerminationLifecycleStatus?: IDropdownReference;
  onSelectableOptionsChange?: (hasSelectable: boolean) => void;
  hideNonSelectable?: boolean;
}

const LegoCategoryDropdown = (props: ILegoCategoryDropdownProps): JSX.Element => {
  const {
    value,
    label,
    required,
    errors,
    handleChange,
    valueKey,
    outputKey,
    watchTerminationLifecycleStatus,
    onSelectableOptionsChange,
    hideNonSelectable,
    disabled,
  } = props;
  const { loading, data: legoCategoriesData } = useQuery(GET_LEGO_CATEGORIES_QUERY);
  const { legoCategories } = !loading && legoCategoriesData ? legoCategoriesData : [];

  const updatedLegoCategories = watchTerminationLifecycleStatus
    ? legoCategories?.map((legoCategory: ILegoCategory) => ({
        ...legoCategory,
        isSelectable:
          legoCategory.terminationLifecycleStatusId === watchTerminationLifecycleStatus?.id,
      }))
    : legoCategories;

  if (onSelectableOptionsChange) {
    const hasSelectable = updatedLegoCategories?.some((cat: ILegoCategory) => cat.isSelectable);
    onSelectableOptionsChange(!!hasSelectable);
  }

  const filteredLegoCategories = hideNonSelectable
    ? updatedLegoCategories?.filter((cat: ILegoCategory) => cat.isSelectable)
    : updatedLegoCategories;

  return (
    <QueryBasedDropdown
      value={value as IDropdownReference}
      label={label}
      required={required}
      outputKey={outputKey}
      dropdownOptionsData={filteredLegoCategories}
      errors={errors}
      handleChange={handleChange}
      valueKey={valueKey}
      disabled={disabled}
    />
  );
};

export default LegoCategoryDropdown;
